import React from 'react';

const ErrorPage = ({ onRetry, errorMessage }) => {
  const handleRetry = () => {
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name.trim() + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/';
    });
    sessionStorage.clear();
    localStorage.clear();
    if (onRetry) {
      onRetry();
    } else {
      window.location.reload();
    }
  };

  const handleSupport = () => {
    window.location.href = 'mailto:support@miratsinsights.com?subject=App Error - Need Assistance&body=Hi Support Team,%0D%0A%0D%0AI encountered an error while using the application.%0D%0A%0D%0AError Details: ' + encodeURIComponent(errorMessage || 'Unknown error');
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Error Icon */}
        <div style={styles.iconWrapper}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
            <path d="M12 9v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" 
              stroke="#DC2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>

        {/* Text */}
        <h1 style={styles.title}>Unable to Load</h1>
        <p style={styles.message}>
          {errorMessage || 'We couldn\'t connect to our servers. Please check your connection and try again.'}
        </p>

        {/* Buttons */}
        <div style={styles.buttons}>
          <button style={styles.primaryBtn} onClick={handleRetry}>
            Try Again
          </button>
          <button style={styles.secondaryBtn} onClick={handleSupport}>
            Contact Support
          </button>
        </div>

        <p style={styles.hint}>
          This will clear your session and reload the page.
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#F9FAFB',
    padding: '24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
  content: {
    textAlign: 'center',
    maxWidth: '400px',
  },
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '80px',
    height: '80px',
    backgroundColor: '#FEE2E2',
    borderRadius: '50%',
    marginBottom: '24px',
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    color: '#111827',
    margin: '0 0 12px 0',
  },
  message: {
    fontSize: '15px',
    color: '#6B7280',
    lineHeight: '1.6',
    margin: '0 0 32px 0',
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  primaryBtn: {
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: '500',
    color: '#fff',
    backgroundColor: '#111827',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  secondaryBtn: {
    padding: '12px 24px',
    fontSize: '15px',
    fontWeight: '500',
    color: '#374151',
    backgroundColor: '#fff',
    border: '1px solid #D1D5DB',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  hint: {
    fontSize: '13px',
    color: '#9CA3AF',
    marginTop: '24px',
  },
};

export default ErrorPage;
